import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconWTM = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
        data-fill-none
      >
        <path
          d="M4.73437 4.97021C4.63081 4.97021 4.54688 4.88628 4.54688 4.78272C4.54688 4.67918 4.63081 4.59521 4.73437 4.59521"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.01562 4.97021C7.91206 4.97021 7.82812 4.88628 7.82812 4.78272C7.82812 4.67918 7.91206 4.59521 8.01562 4.59521"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2031 4.97021C11.0995 4.97021 11.0156 4.88628 11.0156 4.78272C11.0156 4.67918 11.0995 4.59521 11.2031 4.59521"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.73438 4.97021C4.83793 4.97021 4.92187 4.88628 4.92187 4.78272C4.92187 4.67918 4.83793 4.59521 4.73438 4.59521M8.01562 4.97021C8.11918 4.97021 8.20312 4.88628 8.20312 4.78272C8.20312 4.67918 8.11918 4.59521 8.01562 4.59521M22.8008 12.6563V3.65625C22.8008 2.85625 22.2408 2.15625 21.4008 2.15625H3.20078C2.45411 2.15625 1.80078 2.85625 1.80078 3.65625V21.6563C1.80078 22.4563 2.45411 23.1563 3.20078 23.1563H7.75078M1.80078 7.3125L22.5469 7.3125M11.2031 4.97021C11.3067 4.97021 11.3906 4.88628 11.3906 4.78272C11.3906 4.67918 11.3067 4.59521 11.2031 4.59521"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1336 22.924L13 23.2292L13.3046 21.095L18.7916 15.608C19.0342 15.3655 19.3631 15.2292 19.7061 15.2292C20.0491 15.2292 20.3781 15.3655 20.6206 15.608C20.8632 15.8506 20.9994 16.1795 20.9994 16.5225C20.9994 16.8655 20.8632 17.1945 20.6206 17.437L15.1336 22.924Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2235 15.7465C19.0176 15.7465 18.8203 15.8283 18.6748 15.9738L13.3097 21.3389L13.1269 22.6194L14.4071 22.4363L19.7722 17.0712C19.9177 16.9257 19.9994 16.7283 19.9994 16.5225C19.9994 16.3167 19.9177 16.1193 19.7722 15.9738C19.6266 15.8283 19.4293 15.7465 19.2235 15.7465ZM17.9432 15.2422C18.2827 14.9027 18.7432 14.7119 19.2235 14.7119C19.7037 14.7119 20.1642 14.9027 20.5037 15.2422C20.8433 15.5818 21.0341 16.0423 21.0341 16.5225C21.0341 17.0027 20.8433 17.4633 20.5037 17.8028L15.0168 23.2898C14.9376 23.3689 14.835 23.4203 14.7242 23.4361L12.5906 23.7413C12.4294 23.7644 12.2667 23.7102 12.1516 23.5951C12.0364 23.48 11.9822 23.3173 12.0052 23.1561L12.3098 21.0219C12.3257 20.9111 12.377 20.8084 12.4562 20.7292L17.9432 15.2422Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  })
);
